import React from 'react';
import { Header } from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  currentUser: any;
  serviceConfig: any;
  onShowBookingForm?: () => void;
  onShowMyBookings?: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ 
  children, 
  currentUser, 
  serviceConfig, 
  onShowBookingForm = () => {}, 
  onShowMyBookings = () => {} 
}) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header 
        currentUser={currentUser} 
        serviceConfig={serviceConfig} 
        onShowBookingForm={onShowBookingForm} 
        onShowMyBookings={onShowMyBookings} 
      />
      <div className="flex-grow">
        {/* Layout content without debug menu items */}
        {children}
      </div>
      <Footer serviceConfig={serviceConfig} />
    </div>
  );
};